import React from 'react';
import {
  CardDivider,
} from 'components/card/Card2';
import { useIntl } from 'react-intl';
import SearchBar from './components/SearchBar/SearchBar';
import Accounts from './components/Accounts/Accounts';
import styles from './style.cssmodule.css';
import { AccountsProvider } from './contexts/AccountsContext';

function AccountsContainer() {
  const { formatMessage: t } = useIntl();
  return (
    <AccountsProvider>
      <div className={styles.background}>
        <div className={styles.container}>
          <h2 className={styles.pageTitle}>{t({ id: 'subtitle.accounts' })}</h2>
          <SearchBar />
          <CardDivider />
          <Accounts />
        </div>
      </div>
    </AccountsProvider>
  );
}

module.exports = AccountsContainer;



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/AccountsContainer.jsx